import { FC } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import CompanyAvatar from '../CompanyAvatar'
import CompanyInfo from '../CompanyInfo'
import VerifyNotification from '../VerifyNotification'
import AddCompanyButton from './AddCompanyButton'
import { getSelectedCompanyId } from 'store/me'

import { menuItemStyles } from '../../_styles'
import { CheckIcon } from 'components/Common/Icons'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: 8px;
  width: 256px;
  min-width: 256px;
  max-height: calc(100vh - 96px);
  border-radius: 8px;
  background: var(--grey-100, #121432);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.24),
    0 0 0 1px rgba(255, 255, 255, 0.08) inset;
  z-index: var(--z-index-tooltip);
  position: absolute;
  top: 0;
  left: calc(100% + 8px);
  overflow: hidden;
`

const ListItem = styled.div`
  display: flex;
  padding: 0 8px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`

const Content = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  align-self: stretch;

  ${menuItemStyles()};
`

const List = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  padding: 8px 0;
  max-width: 100%;
  overflow: hidden auto;
`

interface CompaniesListProps {
  items: any[]
  collapsed: boolean
  onSelectCompany: (company: any) => void
  onVerify: () => void
  onHide: () => void
}

const CompaniesList: FC<CompaniesListProps> = props => {
  const { items, collapsed, onSelectCompany, onVerify, onHide } = props

  const selectedId = useSelector(getSelectedCompanyId)

  return (
    <Wrapper>
      {collapsed && <VerifyNotification borderless onVerify={onVerify} />}

      <List>
        {items.map(item => (
          <ListItem key={item.id} onClick={() => onSelectCompany(item)}>
            <Content>
              <CompanyAvatar
                avatar={item?.avatar}
                status={item?.verificationStatus?.code}
              />

              <CompanyInfo data={item} />

              {selectedId === item.id && <IconSelected />}
            </Content>
          </ListItem>
        ))}

        <AddCompanyButton onClick={onHide} />
      </List>
    </Wrapper>
  )
}

const IconSelected = CheckIcon

export default CompaniesList
